import React, { useEffect } from "react";

import PropertyListItem from "./propertyListItem";

const MultiplePropertyValue = props => {
  const { properties, setDrawerSelections, setNewLineItemSelections, multiplePropertiesValueFields } = props;

  useEffect(() => {
    if (!multiplePropertiesValueFields) {
      const propSelections = properties && properties.map(prop => ({ propertyId: prop.id, propertyName: prop.name, selectedField: null }));
      setNewLineItemSelections({ multiplePropertiesValueFields: propSelections });
    }
  }, [properties]);

  const onPropertySelected = propertyId => {
    setDrawerSelections({ currentSectionName: "comparison-field-selection" });
    setNewLineItemSelections({ propertyIdSelected: propertyId });
  };

  return (
    multiplePropertiesValueFields &&
    multiplePropertiesValueFields.map(property => (
      <PropertyListItem
        property={property}
        key={property.propertyId}
        onPropertySelected={() => onPropertySelected(property.propertyId)}
        setDrawerSelections={setDrawerSelections}
        setNewLineItemSelections={setNewLineItemSelections}
      />
    ))
  );
};

export default MultiplePropertyValue;
